<template>
  <div class="bg-container">
    <div class="login-container">
      <!-- 标题 -->
      <div class="header">
        <div class="header1">中国残疾人体育运动管理中心</div>
        <div class="header2">
          <span>课题管理系统</span>
        </div>
      </div>
      <!-- 用户登陆和系统提示区 -->
      <div class="main">
        <el-row>
          <!-- 系统提示 -->
          <el-col :span="12" class="notice">
            <div class="div-notice">
              <div class="gonggao">公告栏</div>
              <div class="line"></div>
              <div class="gonggao-list">
                <a href="https://www.cdpf.org.cn/zwgk/ggtz1/8d9fae9d2a5f4002b044f03fb6422778.htm" target="_blank">
                  <span>2024年度中国残联课题（第二批）指南公告</span>
                  <img src="../../assets/image/new.png" alt="" />
                </a>

                <a href="/static/2024残疾人体育专项研究课题申报要求.docx">
                  2024残疾人体育专项研究课题申报要求
                  <img src="../../assets/image/new.png" alt="" />
                </a>

                <!-- 残疾人体育专项研究课题管理办法、中国残疾人体育运动管理中心课题经费管理办法（修订版）
                放在每年的指南和要求下面 -->
                <a href="/static/2023残疾人体育专项研究课题管理办法.html" target="_blank">
                  残疾人体育专项研究课题管理办法
                  <!-- <img src="../../assets/image/new.png" alt="" /> -->
                </a>
                <a href="/static/中国残疾人体育运动管理中心课题经费管理办法（修订版）.html" target="_blank">
                  中国残疾人体育运动管理中心课题经费管理办法（修订版）
                  <!-- <img src="../../assets/image/new.png" alt="" /> -->
                </a>

                <a href="https://www.cdpf.org.cn/zwgk/ggtz1/972c949f8aab4a4b9beac17cc33ca322.htm">
                  <span>中国残疾人联合会-2023年度中国残联研究课题中标公告</span>
                  <!-- <img src="../../assets/image/new.png" alt="" /> -->
                </a>

                <a href="https://www.cdpf.org.cn/zwgk/ggtz1/ebd0884010d94d17aeb9dff71c1ac823.htm">
                  <span>2023年度中国残联课题指南公告</span>
                  <!-- <img src="../../assets/image/new.png" alt="" /> -->
                </a>

                <a href="/static/2023残疾人体育专项研究课题申报要求及申请书.html" target="_blank">
                  残疾人体育专项研究课题申报要求及申请书
                  <!-- <img src="../../assets/image/new.png" alt="" /> -->
                </a>

                <a href="https://www.cdpf.org.cn/zwgk/ggtz1/d75749efe70e4eafa0b4ff917871876e.htm">
                  <span>2022年度中国残联研究课题中标公告</span>
                  <!-- <img src="../../assets/image/new.png" alt="" /> -->
                </a>

                <a href="/static/中国残联课题管理办法（2020-5-13）.html" target="_blank">
                  中国残联课题管理办法（2020-5-13）
                </a>

                <a href="https://www.cdpf.org.cn/zwgk/ggtz1/0cb0dcc38ab646518671760164058fca.htm">
                  <span>中国残疾人联合会-2021年度中国残联研究课题中标公告</span>
                  <!-- <img src="../../assets/image/new.png" alt="" /> -->
                </a>
                <!-- <a href="/static/2021年度中国残联课题指南公告.html"> -->
                <a href="https://www.cdpf.org.cn/zwgk/ggtz1/b35a19252a084db484e5f3c10f79483c.htm">
                  <span>2021年度中国残联课题指南公告 </span>
                  <!-- <img src="../../assets/image/new.png" alt="" /> -->
                </a>
                <a href="/static/2021年残疾人体育专项研究课题申报要及申请表.docx" target="_blank">
                  2021年残疾人体育专项研究课题申报要及申请表
                  <!-- <img src="../../assets/image/new.png" alt="" /> -->
                </a>
                <a href="/static/2020年度中国残联课题指南公告.html" target="_blank">
                  2020年度中国残联课题指南公告
                </a>
                <a href="/static/2020年度中国残联研究课题中标公告.html" target="_blank">
                  2020年度中国残联研究课题中标公告
                </a>
              </div>
            </div>
          </el-col>
          <!-- 用户登陆 -->
          <el-col :span="12" class="login">
            <el-card class="card-login">
              <div class="login-title">登录</div>
              <el-form class="login-form" :model="loginForm">
                <el-form-item>
                  <el-input v-model="loginForm.userid" placeholder="请输入账号"></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input v-model="loginForm.password" placeholder="请输入密码" show-password></el-input>
                </el-form-item>
              </el-form>
              <div class="div-veryfy">
                <!-- <Verify :type="3" @success="success"></Verify> -->
                <Verify :type="3" @success="success" :barSize="{ width: '300px', height: '40px' }" :showButton="false">
                </Verify>
              </div>
              <!-- <el-button  type="primary" @click.prevent="handleReg()">注册</el-button> -->
              <el-button class="button-login" type="primary" @click.prevent="handleLogin()">登录</el-button>
              <div class="div-reg" @click="handleReg">
                还没账号，立即注册 >>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <div class="footer">
        <p>中国残疾人体育运动管理中心</p>
        <p>
          地址：北京市顺义区后沙峪镇天北路321号 &nbsp;&nbsp; 电话:010-80471809
          &nbsp;&nbsp;传真：010-80471809
        </p>
        <p>ICP备案号 : 京ICP备15050850号-1 ©2007-2019 中国残疾人体育运动管理中心版权所有 </p>
        <div style="width:300px;margin:0 auto; ">
          <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
            <img src="../../assets/image/公安.jpg" style="float:left;" />
            <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">京公网安备
              11011302004271号</p>
          </a>
        </div>
        <p>技术维护: 北京或然科技有限公司 电话: 010-88120103</p>
      </div>
    </div>
    <!-- 注册对话框 -->
    <el-dialog title="用户注册" :visible.sync="addUserFormVisible">
      <el-form label-position="left" label-width="80px" :model="addUserForm" ref="ruleForm" :rules="addUserFormRules"
        class="demo-ruleForm">
        <el-form-item label="账号" prop="userid">
          <el-input v-model="addUserForm.userid" autocomplete="off" id="id-userid" @blur="useridVerify()"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password" :label-width="formLabelWidth">
          <el-input v-model="addUserForm.password" show-password autocomplete="off" id="id-pass"
            @blur="confirmPassRegex()">
          </el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="passwordConfirm" :label-width="formLabelWidth">
          <el-input v-model="addUserForm.passwordConfirm" show-password autocomplete="off" id="id-pass-confirm">
          </el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="username" :label-width="formLabelWidth">
          <el-input v-model="addUserForm.username" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="gender" :label-width="formLabelWidth">
          <el-select v-model="addUserForm.gender" placeholder="请选择性别" style="width: 100%;">
            <el-option v-for="item in optionsGender" :key="item" :value="item" :label="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="民族" prop="national" :label-width="formLabelWidth">
          <el-input v-model="addUserForm.national" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="出生年月" prop="birth" :label-width="formLabelWidth">
          <el-date-picker v-model="addUserForm.birth" type="date" placeholder="选择日期" format="yyyy年MM月dd日"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="单位" prop="organization" :label-width="formLabelWidth">
          <el-input v-model="addUserForm.organization" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="职称级别" prop="title_level" :label-width="formLabelWidth">
          <el-select v-model="addUserForm.title_level" placeholder="请选择职称级别" style="width:100%;">
            <el-option v-for="item in optionsTitleLevel" :key="item" :label="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="专业职称" prop="title" :label-width="formLabelWidth">
          <el-input v-model="addUserForm.title" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="行政职务" prop="duty" :label-width="formLabelWidth">
          <el-input v-model="addUserForm.duty" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="研究专长" prop="major" :label-width="formLabelWidth">
          <el-input v-model="addUserForm.major" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="最后学历" prop="education" :label-width="formLabelWidth">
          <el-select v-model="addUserForm.education" placeholder="请选择最后学历" style="width: 100%;">
            <el-option v-for="item in optionsEducation" :key="item" :lable="item" :value="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="最后学位" prop="degree" :label-width="formLabelWidth">
          <el-select v-model="addUserForm.degree" placeholder="请选择最后学位" style="width: 100%;">
            <el-option v-for="item in optionsDegree" :key="item" :value="item" :label="item">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所在省（自治区、直辖市）" prop="province" label-width="30%">
          <el-input v-model="addUserForm.province" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="通讯地址" prop="addr" :label-width="formLabelWidth">
          <el-input v-model="addUserForm.addr" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="tel" :label-width="formLabelWidth">
          <el-input v-model="addUserForm.tel" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="E-mail" prop="email" :label-width="formLabelWidth">
          <el-input v-model="addUserForm.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮政编码" prop="zipcode" :label-width="formLabelWidth">
          <el-input v-model="addUserForm.zipcode" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <!-- 处理职称文件 -->
      <div class="div-file">
        <!-- 上传附件 -->
        <div class="div-upload">
          <input type="file" class="input-upload" @change="uploadFileEdit" />
          <button class="button-upload">
            上传职称证明
            <i class="el-icon-upload el-icon--right"></i>
          </button>
          <!-- <el-button type="primary" size="small" class="button-upload">上传职称证明
            <i class="el-icon-upload el-icon--right"></i>
          </el-button> -->
        </div>

        <!-- 文件列表 -->
        <el-table :data="fileList" border style="width:551px;" :header-cell-style="{ background: '#fafafa' }">
          <el-table-column prop="name" label="文件名" width="300"></el-table-column>
          <el-table-column prop="create_time" label="创建时间" width="150">
            <template slot-scope="scope">
              {{ scope.row.create_time | fmtdate }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button size="mini" :plain="true" type="primary" icon="el-icon-download" circle
                @click="downloadFile(scope.row)"></el-button>
              <el-button size="mini" :plain="true" type="danger" icon="el-icon-delete" circle
                @click="deleteFile(scope.row)">
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addUserFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUserFormButton()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Verify from "vue2-verify";
import fileDownload from "js-file-download";

export default {
  components: {
    Verify
  },

  data() {
    return {
      loginForm: {
        userid: "",
        password: "",
        ip_data: ""
      },
      data: {},
      verifyCode: false,
      // 指南文件
      guideFileList: [
        // { name: '申报书模板.doc', path: './uploadfiles/指南文件/申报书模板.doc' },
        {
          name: "体管中心科研课题经费管理办法 .docx",
          path: "./uploadfiles/指南文件/体管中心科研课题经费管理办法 .docx"
        },
        {
          name: "中国残联课题管理办法（2020-5-13）.docx",
          path: "./uploadfiles/指南文件/中国残联课题管理办法（2020-5-13）.doc"
        }
      ],
      // 用户注册
      addUserFormVisible: false,
      formLabelWidth: "",
      addUserForm: {},
      // 上传的职称文件
      fileList: [],
      // 添加用户对话框校验规则
      addUserFormRules: {
        userid: [{
          required: true,
          message: "请输入账号",
          trigger: "blur"
        },
        {
          min: 2,
          max: 32,
          message: "长度在 2 到 32 个字符",
          trigger: "blur"
        }
        ],
        password: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }],
        passwordConfirm: [{
          required: true,
          message: "请输入密码",
          trigger: "blur"
        }],
        username: [{
          required: true,
          message: "请输入姓名",
          trigger: "blur"
        }],
        gender: [{
          required: true,
          message: "请输入性别",
          trigger: "blur"
        }],
        national: [{
          required: true,
          message: "请输入民族",
          trigger: "blur"
        }],
        birth: [{
          required: true,
          message: "请输入出生年月",
          trigger: "blur"
        }],
        organization: [{
          required: true,
          message: "请输入单位",
          trigger: "blur"
        }],
        title_level: [{
          required: true,
          message: "请选择职称级别",
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: "请输入专业职称",
          trigger: "blur"
        }],
        duty: [{
          required: true,
          message: "请输入行政职务",
          trigger: "blur"
        }],
        major: [{
          required: true,
          message: "请输入研究专长",
          trigger: "blur"
        }],
        education: [{
          required: true,
          message: "请输入最后学历",
          trigger: "blur"
        }],
        degree: [{
          required: true,
          message: "请输入最后学位",
          trigger: "blur"
        }],
        province: [{
          required: true,
          message: "请输入所在省（自治区、直辖市）",
          trigger: "blur"
        }],
        addr: [{
          required: true,
          message: "请输入通讯地址",
          trigger: "blur"
        }],
        tel: [{
          required: true,
          message: "请输入联系电话",
          trigger: "blur"
        }],
        email: [{
          required: true,
          message: "请输入E-mail",
          trigger: "blur"
        }],
        zipcode: [{
          required: true,
          message: "请输入邮政编码",
          trigger: "blur"
        }]
      },

      // 下拉框
      optionsTitleLevel: ["博士毕业", "副高", "正高"],
      optionsGender: ["男", "女"],
      optionsEducation: ["本科", "研究生"],
      optionsDegree: ["学士", "硕士", "博士"]
    };
  },
  created() { },
  mounted() {
    // 使用指南
    this.$alert(
      `
      <div style="margin:0 20px 0 20px ;">
          <h3>申报使用指南</h3>
          <h4>1. 新用户请点击注册按钮进行注册。</h4>
          <h4>2. 新注册的用户，作为申请人须具有副高级（含）以上专业技术职务或具有博士学位或副处级（含）以上行政职务，且需将职称证明扫描后上传。</h4>
          <h4>3. 新用户注册后，需待管理员进行验证并激活后方可正常登陆使用。</h4>
          <h4>4. 申报流程：详见申报书管理页面。</h4>
          <h4>5. 申报内容以在线生成为准，同时需提交的纸质版和电子版须与线上一致。</h4>          
          <h3 style="text-align:center">技术支持：17701051303</h3>          
        </div>
        `, {
      dangerouslyUseHTMLString: true
    }
    );
  },
  methods: {
    // 验证码
    success(e) {
      //成功后的返回
      this.verifyCode = true;
    },

    // 登陆
    async handleLogin() {
      // 非涉密系统警告
      this.$alert(
        '非涉密系统，严禁上传、保存、处理、传输涉密文件数据！',
        '警告',
        {
          confirmButtonText: '我知道了',
          type: 'warning',
          showClose: false, // 禁用右上角的关闭按钮
          customClass: 'security-warning'
        }
      );

      // 判断验证码是否正确
      if (!this.verifyCode) {
        return this.$message.error("请完成验证！");
      }
      // 判断账号密码不能为空
      if (!this.loginForm.userid || !this.loginForm.password) {
        return this.$message.error("账号和密码不能为空！");
        // return this.$message.warning("账号或密码不能为空！")
      }

      const res = await this.axios.post("/login/", this.loginForm);
      this.data = res.data;

      if (this.data.code === 1000) {
        // 是否激活
        if (this.data.is_active) {
          // console.log(this.data.is_active)
          //获取菜单列表
          // let url = '/role/?role_id=' + this.data.role_id
          // let resMenu = await this.axios.get('/role/?role_id=' + this.data.role_id)

          let resMenu = await this.axios.post("/roleInfo/", {
            role_id: this.data.role_id
          });

          if (resMenu.data.code == 1000) {
            localStorage.setItem("menus", JSON.stringify(resMenu.data.menus));
          } else {
            this.$message.error("获取权限失败！");
          }

          this.$message.success(this.data.msg);
          //保存token
          localStorage.setItem("userid", this.data.userid);
          localStorage.setItem("username", this.data.username);
          localStorage.setItem("token", this.data.token);
          localStorage.setItem("role_id", this.data.role_id);
          localStorage.setItem("birth", this.data.birth);
          // console.log(this.data)
          this.$router.push("home");
        } else {
          this.$message.warning("您的账号正在审核中，请稍后再试！");
        }
      } else {
        this.$message.warning(this.data.msg);
      }
    },

    // 注册按钮
    handleReg() {
      // 临时注释
      // this.addUserFormVisible = true;

      // 临时关闭
      this.$alert('系统还未开放注册，具体开放时间请查阅相关指南公告！', {
        dangerouslyUseHTMLString: true
      });

    },


    async useridVerify() {
      // 验证userid是否被占用
      let data = {
        userid: this.addUserForm.userid
      };
      const res = await this.axios.post("/getUserId/", data);
      // console.log(res);
      if (res.data.code == 1001) {
        document.getElementById("id-userid").focus();
        return this.$message.error("账号已被注册，请更换账号名称！");
      }

      // 判断用户名是否包含特殊字符
      var uPattern = /^[a-zA-Z][a-zA-Z0-9_-]{3,17}$/;
      if (!uPattern.test(this.addUserForm.userid)) {
        document.getElementById("id-userid").focus();
        return this.$message.error(
          "用户名必须以字母开头，且只能由字母、数字、下划线、减号组成！"
        );
      }
      // 刷新文件列表
      let pid = "职称证明/" + this.addUserForm.userid;
      this.getFileList(pid)
    },


    // 新增注册账户
    async addUserFormButton() {
      // 验证userid是否被占用
      let data = {
        userid: this.addUserForm.userid
      };
      let resUser = await this.axios.post("/getUserId/", data);
      // console.log(res);
      if (resUser.data.code == 1001) {
        document.getElementById("id-userid").focus();
        return this.$message.error("账号已被注册，请更换账号名称！");
      }

      // 判断用户名是否包含特殊字符
      var uPattern = /^[a-zA-Z][a-zA-Z0-9_-]{3,17}$/;
      if (!uPattern.test(this.addUserForm.userid)) {
        document.getElementById("id-userid").focus();
        return this.$message.error(
          "用户名必须以字母开头，且只能由字母、数字、下划线、减号组成！"
        );
      }

      this.confirmPass()

      // 验证密码非空
      if (!this.addUserForm.password) {
        return this.$message.error("请设置密码！");
      }

      //验证邮箱的规则
      const regEmail = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/;
      if (!regEmail.test(this.addUserForm.email)) {
        return this.$message.error("请填写正确的邮箱！");
      }

      // 判断上传文件不能为空
      if (this.fileList.length < 1) {
        return this.$message.error("请上传职称证明文件！");
      }

      this.addUserForm.role_id = 2;
      let userData = this.addUserForm;
      delete userData.passwordConfirm;
      const res = await this.axios.post("/addUser/", userData);

      if (res.data.code === 1000) {
        this.$message({
          message: "注册成功，请等待管理员审核。",
          type: "success",
          duration: 5000,
          showClose: true
        });
      }
      this.addUserFormVisible = false;
    },


    // 验证密码复杂度
    confirmPassRegex() {
      var pwdRegex = new RegExp('(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}');
      if (!pwdRegex.test(this.addUserForm.password)) {
        document.getElementById("id-pass").focus();
        return this.$message.warning("您的密码复杂度太低（密码中必须包含字母、数字、特殊字符，且长度为8-30个字符），请修改密码！");
      }
    },


    // 验证密码是否一致
    confirmPass() {
      if (this.addUserForm.password != this.addUserForm.passwordConfirm) {
        return this.$message.warning("密码不一致，请重新填写！");
        // setTimeout(() => {
        //   document.getElementById("id-pass-confirm").focus();
        // }, 500);
      }
    },

    // 获取附件列表
    async getFileList(pid) {
      // const res = await this.axios.get(`/fileList/?pid=${pid}`)
      const res = await this.axios.post(`/handleFileList/`, {
        pid: pid
      });

      if (res.data.code === 1000) {
        this.fileList = res.data.results;
      } else {
        this.$message.warning("获取文件列表错误");
      }
    },

    //上传文件
    uploadFileEdit(e) {
      // 判断文件类型
      // in 操作符只能判断对象变量
      let fileType = {
        pdf: "pdf",
        jpg: "jpg",
        png: "png"
      };
      if (e.target.files[0].name.slice(-3) in fileType) {
        // pass
      } else {
        return this.$message.error("请上传pdf、jpg、png格式的文件！");
      }
      let formData = new FormData();
      let pid = "职称证明/" + this.addUserForm.userid;
      let data = JSON.stringify({
        pid
      });
      formData.append("file", e.target.files[0]);
      formData.append("data", data); // 上传文件的同时， 也可以上传其他数据
      let url = `/uploadFile/`;
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      this.axios.post(url, formData, config).then(response => {
        // console.log(response.data)
        this.getFileList(pid);
        // console.log('fileList:  ', this.fileList)
      });
    },

    // 删除文件
    async deleteFile(item) {
      // let res = await this.axios.delete('/fileList/' + item.id + '/')
      // let res = await this.axios.delete('/handleFileList/', {
      //   "id": item.id
      // })
      let data1 = {
        method: "delete",
        id: item.id
      };
      let res = await this.axios.post("/handleFileList/", data1);

      if (res.data.code === 1000) {
        this.getFileList(item.pid);
      }
      let data = {
        path: item.path
      };
      let resDelete = await this.axios.post("/deleteFile/", data);
    },

    // 下载文件
    downloadFile(item) {
      let url = `/downloadFile/?path=${item.path}&name=${item.name}`;
      let params = {
        path: item.path,
        name: item.name
      };
      this.axios
        .post(url, params, {
          responseType: "arraybuffer"
        })
        .then(res => {
          fileDownload(res.data, item.name);
        });
    }
  }
};

</script>

<style lang="less" scoped>
a {
  display: block;
}

.bg-container {
  display: flex;
  justify-content: center;
  /* 水平居中 */
  align-items: center;

  /* 垂直居中 */
  .login-container {
    width: 1440px;
    height: 100%;

    .header {
      width: 100%;
      height: 120px;
      display: flex;
      justify-content: center;
      /* 水平居中 */
      align-items: center;

      /* 垂直居中 */
      .header1 {
        width: 364px;
        height: 28px;
        opacity: 1;
        font-size: 28px;
        font-weight: 500;
        text-align: center;
        color: #333333;
        line-height: 42px;
      }

      .header2 {
        margin-left: 10px;
        width: 128px;
        height: 28px;
        opacity: 1;
        background: linear-gradient(90deg, #00c7c0 2%, #007ec7);
        border-radius: 14px;
        border-bottom-left-radius: 0;
        text-align: center;

        span {
          width: 96px;
          font-size: 16px;
          text-align: left;
          color: #ffffff;
          line-height: 24px;
        }
      }
    }

    .main {
      margin: 5px 0;
      width: 100%;
      height: 438px;
      background-image: url("../../assets/image/背景.png");

      .notice {
        .div-notice {
          margin-left: 220px;
          margin-top: 30px;

          .gonggao {
            width: 72px;
            height: 24px;
            font-size: 24px;
            font-weight: 500;
            text-align: left;
            color: #ffffff;
            line-height: 36px;
          }

          .line {
            margin-top: 20px;
            width: 305px;
            height: 1px;
            background: rgba(255, 255, 255, 0.6);
          }

          .gonggao-list {
            height: 320px;
            overflow-y: auto;

            a {
              margin-top: 30px;
              width: 100%;
              height: 14px;
              font-size: 14px;
              text-align: left;
              color: #ffffff;
              line-height: 30px;
              text-decoration: none;

              img {
                width: 22px;
                height: 24px;
              }
            }
          }
        }
      }

      .login {
        .card-login {
          width: 343px;
          height: 520px;
          margin-top: -1px;
          margin-left: 100px;
          padding-left: 20px;
          padding-right: 20px;

          .login-title {
            margin: 30px 0 30px 0;
            font-size: 24px;
            font-weight: 800;
            text-align: center;
          }

          .login-form {
            .el-form-item {
              margin-top: 40px;
            }
          }

          .div-veryfy {
            margin-top: 40px;

            .verify-msg {
              font-size: 14px;
              font-family: PingFangSC, PingFangSC-Regular;
              font-weight: 400;
              text-align: right;
              color: #999999;
              line-height: 20px;
            }
          }

          .button-login {
            margin-top: 50px;
            width: 303px;
          }

          .div-reg {
            margin-top: 40px;
            height: 14px;
            font-size: 14px;
            text-align: center;
            color: #999999;
            line-height: 21px;
            cursor: pointer;
          }
        }
      }
    }

    .footer {
      margin-top: 185px;
      width: 100%;
      height: 38px;
      font-size: 12px;
      font-weight: 400;
      text-align: center;
      color: #888888;
      line-height: 20px;
    }
  }

  .div-file {
    margin-top: 15px;

    .div-upload {
      height: 47px;
      position: relative;

      .input-upload {
        width: 125px;
        height: 33px;
        position: absolute;
        z-index: 1;
        opacity: 0;
      }

      .button-upload {
        width: 125px;
        height: 33px;
        position: absolute;
      }

      .input-upload:hover {
        cursor: pointer;
      }
    }
  }
}

.el-dialog {
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue